module.exports = __webpack_public_path__ + "static/media/account-image1.495b5f07.png";